<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="分类">
              <a-select show-search option-filter-prop="children" v-model="queryParams.uomClassList" mode="multiple" :max-tag-text-length="2" :max-tag-count="2" @change="uomClassOnChange">
                <a-select-option v-for="(item) in uomClassOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="单位">
              <a-select show-search option-filter-prop="children" v-model="queryParams.unitOfMeasureList" mode="multiple" :max-tag-text-length="2" :max-tag-count="2">
                <a-select-option v-for="(item) in unitOfMeasureList" :key="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="基本单位">
              <a-select show-search option-filter-prop="children" v-model="queryParams.baseUomFlagList" mode="multiple" :max-tag-text-length="2" :max-tag-count="2">
                <a-select-option v-for="(item) in baseUomFlagOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParams.status" allowClear>
                  <a-select-option v-for="(item) in statusOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apitSysCompanySubjectNewExport" ref="download" />
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['mdm:mdmUomUnitsOfMeasure:add']">新增</a-button>
      <a-button @click="handleExport" v-hasPermi="['mdm:mdmUomUnitsOfMeasure:export']">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.UNIT_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="baseUomFlag" slot-scope="{ record }">
            {{ baseUomFlagFormat(record) }}
          </span>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="status" slot-scope="{ record }">
            <a-popconfirm
              ok-text="确定"
              cancel-text="取消"
              @confirm="confirmHandleStatus(record)"
              @cancel="cancelHandleStatus(record)"
            >
              <span slot="title">请确认是否<b>{{ record.status === 'Y' ? '停用' : '启用' }}</b>该单位</span>
              <a-switch :checked="record.status === 'Y'" />
            </a-popconfirm>
          </template>
        </ls-api-table>
        <unit-add
          ref="createModal"
          :uomClassOptions="uomClassOptions"
          @handle-success="onSearch"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apiMdmUomUnitsOfMeasureList, apiMdmUomUnitsOfMeasureUpdate, apiMdmUomUnitsOfMeasureUnitOfMeasureList, apitSysCompanySubjectNewExport } from '@/api/mdm/units/unit'
import UnitAdd from './components/unit-add'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from "@/views/components/download-modal/download-modal";
export default {
  name: 'Unit',
  components: {
    UnitAdd, DownloadModal
  },
  data () {
    return {
      apitSysCompanySubjectNewExport,
      // 表格配置1
      tableProps: {
        requestApi: generateLsTableResData(apiMdmUomUnitsOfMeasureList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        uomClassList: undefined,
        unitOfMeasureList: undefined,
        baseUomFlagList: undefined,
        status: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 状态快码
      statusOptions: [
        {
          dictLabel: "有效",
          dictValue: "Y"
        },
        {
          dictLabel: "无效",
          dictValue: "N"
        }
      ],
      // 基本单位
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 表格字段
      columns: [
        {
          title: '分类',
          dataIndex: 'uomClass',
          align: 'center',
          width: 100
        },
        {
          title: '说明',
          dataIndex: 'unitDesc',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '基本单位',
          dataIndex: 'baseUomFlag',
          ellipsis: true,
          scopedSlots: { customRender: 'baseUomFlag' },
          align: 'center'
        },
        {
          title: '单位',
          dataIndex: 'unitOfMeasure',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '最后修改人',
          dataIndex: 'updateName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 150,
          align: 'center'
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 150,
          align: 'center'
        }
      ],
      uomClassOptions: [],
      unitOfMeasureList: []
    }
  },
  created () {
    this.getUnitOfMeasureList()

    const lookupQueryParams = {
      lookupType: 'MDM_UOM_CLASSES',
      current: 1,
      pageSize: 100
    }
    this.getLookupListData(lookupQueryParams).then().then(response => {
      this.uomClassOptions = response.rows
    })
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    uomClassOnChange () {
      this.getUnitOfMeasureList()
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('mdm/mdmUomUnitsOfMeasure/export', {
      //   ...this.queryParams
      // }, `单位_${new Date().getTime()}.xlsx`)
    },
    // 单位下拉框数据
    getUnitOfMeasureList () {
      this.queryParams.unitOfMeasureList = undefined
      const params = {
        uomClassList: this.queryParams.uomClassList
      }
      apiMdmUomUnitsOfMeasureUnitOfMeasureList(params).then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          const arr = res.data;
          const list = [];
          arr.forEach(element => {
            const obj = {
              key: element.realValue,
              value: element.label
            }
            list.push(obj)
          });
          this.unitOfMeasureList = list
        }
      })
    },
    // 列表-状态字段切换
    confirmHandleStatus (row) {
      const text = row.status === 'Y' ? '停用' : '启用'
      row.status = row.status === 'Y' ? 'N' : 'Y'
      apiMdmUomUnitsOfMeasureUpdate(row)
      .then(() => {
        this.$message.success(
          text + '成功',
          3
        )
        this.onSearch()
      }).catch(function () {
        row.status = row.status === 'Y' ? 'N' : 'Y'
        this.$message.error(
          text + '发生异常',
          3
        )
      })
    },
    cancelHandleStatus (row) {
    },
    baseUomFlagFormat (row, column) {
      return this.selectDictLabel(this.baseUomFlagOptions, row.baseUomFlag)
    },
    // 表单搜索
    onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        uomClassList: undefined,
        unitOfMeasureList: undefined,
        baseUomFlagList: undefined,
        status: undefined
      }
      this.onSearch()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
</style>
